module.exports = __webpack_public_path__ + "static/img/egg_b_13.6476d65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_13.png
// module id = tUGq
// module chunks = 1